import {
  GET_DEFAULT_LEGAL_ENTITY_REQUEST,
  GET_DEFAULT_LEGAL_ENTITY_SUCCESS,
  GET_DEFAULT_LEGAL_ENTITY_FAILURE
} from 'actions';

// eslint-disable-next-line default-param-last
function defaultLegalEntity(state = {
  isGettingDefaultLegalEntity: false,
  defaultLegalEntity: {
    legalEntity: null,
    count: 0
  },
}, action) {
  switch (action.type) {
    case GET_DEFAULT_LEGAL_ENTITY_REQUEST:
      return {
        ...state,
        isGettingDefaultLegalEntity: action.isGettingDefaultLegalEntity
      };
    case GET_DEFAULT_LEGAL_ENTITY_SUCCESS:
      return {
        ...state,
        isGettingDefaultLegalEntity: action.isGettingDefaultLegalEntity,
        defaultLegalEntity: {
          legalEntity: action.defaultLegalEntity.legalEntity,
          count: action.defaultLegalEntity.count
        }
      };
    case GET_DEFAULT_LEGAL_ENTITY_FAILURE:
      return {
        ...state,
        isGettingDefaultLegalEntity: action.isGettingDefaultLegalEntity,
        defaultLegalEntity: {
          legalEntity: null,
          count: 0
        }
      };
    default:
      return state;
  }
}

export default defaultLegalEntity;
